<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { releases } from '../app/content'
import { useSiteLocale } from '../composables/useSiteLocale'
const { t } = useI18n()
const { currentLocale } = useSiteLocale()
const entries = computed(() => releases[currentLocale.value])
</script>

<template>
  <div class="simple-page changelog-page">
    <header class="simple-page__hero">
      <span class="eyebrow">FIELD NOTES / CHANGELOG</span>
      <h1>{{ currentLocale === 'zh-CN' ? '更新内容' : 'Release notes' }}</h1>
      <p>Motexa Ride</p>
    </header>
    <div class="release-list">
      <article v-for="release in entries" :id="release.version" :key="release.version" class="release-entry">
        <div class="release-entry__meta">
          <span>{{ release.date }}</span><b>{{ release.version }}</b>
          <i :class="`release-chip release-chip--${release.channel}`">{{ release.channel }}</i>
        </div>
        <div class="release-entry__content">
          <h2>{{ release.title }}</h2><p>{{ release.summary }}</p>
          <section v-for="group in release.groups" :key="group.category" class="release-group">
            <h3>{{ group.label }}</h3>
            <ul><li v-for="change in group.changes" :key="change">{{ change }}</li></ul>
          </section>
          <ul v-if="release.changes.length"><li v-for="change in release.changes" :key="change">{{ change }}</li></ul>
        </div>
      </article>
    </div>
    <div class="docs-callout"><span>{{ currentLocale === 'zh-CN' ? '想从头了解产品？' : 'Want the full product story?' }}</span><RouterLink to="/">{{ t('common.explore') }} ↗</RouterLink></div>
  </div>
</template>

<style scoped>
.changelog-page .simple-page__hero h1 { font-size: 48px; letter-spacing: 0; }
.release-entry__content { min-width: 0; }
.release-entry__content h2 { font-size: 24px; letter-spacing: 0; }
.release-group { margin-top: 28px; }
.release-group h3 { margin: 0; color: var(--ink); font-size: 16px; font-weight: 500; letter-spacing: 0; }
.release-group ul { margin-top: 14px; }
.release-group li { line-height: 1.8; overflow-wrap: anywhere; }
@media (max-width: 640px) { .changelog-page .simple-page__hero h1 { font-size: 36px; } }
</style>
